
/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
        // JavaScript to be fired on all pages
		$('.textbox.ms .wpb_wrapper').matchHeight();
		$('.vc_cta3-container .high-cta').matchHeight();
		$('.newsletter-box .mh ').matchHeight();
		$('.otw_blog_manager-blog-title').matchHeight();
		$('.post').matchHeight();
		$('.post header').matchHeight();
		$('.post .meta-wrapper').matchHeight();
		$('.post .entry-title-wrapper').matchHeight();
//		$('.post .entry-title').matchHeight();
		
		$('[data-toggle="tooltip"]').tooltip();		
		$('.vc_column-inner a').each(function(){
			if ($(this).attr('href')){
				if ($(this).attr('href').indexOf('.pdf') > -1){
					
					if (!$(this).hasClass('pdf-link') && !$(this).hasClass('vc_single_image-wrapper')){
						$(this).addClass('pdf-link');
					}
					//$(this).parent('li').css("list-style-type","none");
					//$(this).parent('li').css("margin-left","-20px");
					this.target="_blank";
				}

				if ($(this).attr('href').indexOf('.pptx') > -1){
				//	$(this).addClass('ppt-link');
					//$(this).parent('li').css("list-style-type","none");
					//$(this).parent('li').css("margin-left","-20px");
					this.target="_blank";
				}

				if ($(this).attr('href').indexOf('.docx') > -1){
				//	$(this).addClass('doc-link');
					//$(this).parent('li').css("list-style-type","none");
					//$(this).parent('li').css("margin-left","-20px");
					this.target="_blank";
				}
				if ($(this).attr('href').indexOf('.dotx') > -1){
				//	$(this).addClass('dot-link');
					//$(this).parent('li').css("list-style-type","none");
					//$(this).parent('li').css("margin-left","-20px");
					this.target="_blank";
				}
			}	
			$('a.pdf-link').each(function(){
				if (!$(this).parent('li').parent('ul').hasClass('pdf-list')){
					$(this).parent('li').parent('ul').addClass('pdf-list');				
				}
			});
		
	
		


		});
		$('#main_nav_container').affix({
		      offset: {
		        top: $('header.banner').height()
		      }
		});
		$('.widget_nav_menu ul.menu  a').wrap( "<span></span>" );
		$('.nicelists  a').wrap( "<span></span>" );
		$( "<span>&raquo;</span>" ).insertBefore('a.pdf-link');
		$('.otw_blog_manager-pagination .pages').hide();
		$('.otw_blog_manager-pagination .next.page-numbers').html("<i class='glyphicon glyphicon-triangle-right'></i>");
		$('.otw_blog_manager-pagination .prev.page-numbers').html("<i class='glyphicon glyphicon-triangle-left'></i>");		
		$("a[rel='external'], a.external").each(function(){
			this.target="_blank";
	   });
		//$('#breadcrumbs').html(function(index,text){
		//    return text.replace('Home','<span class="glyphicon glyphicon-home" aria-hidden="true"></span>').replace(/»/g,'<span class="glyphicon glyphicon-menu-right" aria-hidden="true"></span>');
		//});

      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired
      }
    },
    // Home page
    'home': {
      init: function() {
        // JavaScript to be fired on the home page
      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    // About us page, note the change from about-us to about_us.
    'about_us': {
      init: function() {
        // JavaScript to be fired on the about us page
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.








/////////////////////////////////////////
